import {
  Button,
  Card,
  CardTitle,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useRef, useState } from "react";
import "./salary.scss";
import Loading from "../loader/loader";
import moment from "moment";

import Form from "reactstrap/lib/Form";
import NkHeader from "../../common/nkheader";
const SalaryAdvancePresentational = ({
  handleChange,
  upData,
  clear,
  search,
  salaryProfile,
  dataLoading,
  salaryAdvancedetails,
  SalaryHistory,
  resonEligibilty,
  detailsLoading,
  historyloading,
}) => {
  const profiledata = [
    {
      label: "Employee ID",
      value: `${salaryProfile && salaryProfile.employeeId}`,
    },
    {
      label: "First Name",
      value: `${salaryProfile && salaryProfile.firstName}`,
    },
    {
      label: "Last Name",
      value: `${salaryProfile && salaryProfile.lastName}`,
    },
    {
      label: "Company",
      value: `${salaryProfile && salaryProfile.corporateName} ${
        salaryProfile.corporateId ? "- " + salaryProfile.corporateId : ""
      }`,
    },
    {
      label: "RMT profile Status",
      value: `${salaryProfile && salaryProfile.rmtProfileStatus}`,
    },
    {
      label: "Emirates ID",
      value: `${salaryProfile && salaryProfile.emiratesId}`,
    },
    {
      label: "Emirates Expiry Date",
      value: `${
        salaryProfile &&
        salaryProfile.emiratesIdExpiryDate &&
        moment(salaryProfile.emiratesIdExpiryDate).format("DD-MM-YY") !==
          "Invalid date"
          ? moment(salaryProfile.emiratesIdExpiryDate).format("DD-MM-YY")
          : ""
      }`,
    },
  ];
  const salarydata = [
    {
      label: "Last Salary Advance Taken on ",
      value: `${
        salaryAdvancedetails && salaryAdvancedetails.lastSalaryAdvanceOn
          ? salaryAdvancedetails.lastSalaryAdvanceOn
          : ""
      }`,
    },
    {
      label: "Last Salary Amount Taken ",
      value: `${
        salaryAdvancedetails && salaryAdvancedetails.salaryAdvanceAmount
          ? salaryAdvancedetails.salaryAdvanceAmount
          : ""
      }`,
    },
    {
      label: "Last salary credited ",
      value: `${
        salaryAdvancedetails && salaryAdvancedetails.lastSalaryCreditOn
          ? salaryAdvancedetails.lastSalaryCreditOn
          : ""
      }`,
    },
    {
      label: "Last Recovery Amount",
      value: `${
        salaryAdvancedetails && salaryAdvancedetails.lastRecoveryAmount
          ? salaryAdvancedetails.lastRecoveryAmount
          : ""
      }`,
    },
    {
      label: "Pending Amount to recover",
      value: `${
        salaryAdvancedetails && salaryAdvancedetails.recoveryAmountDue
          ? salaryAdvancedetails.recoveryAmountDue
          : ""
      }`,
    },
  ];
  return (
    <>
      <Container fluid>
        <NkHeader title="Salary Advance" />
        <Card>
          <CardBody>
            <Form>
              <Row className="rowGroup">
                <Col lg="2">
                  <label
                    htmlFor="example3cols2Input"
                    className="form-control-label"
                  >
                    Mobile
                  </label>
                </Col>
                <Col lg="1">:</Col>
                <Col lg="3">
                  <Input
                    id="example3cols2Input"
                    type="text"
                    name="mobile"
                    placeholder="98776XXXXXXXX"
                    value={upData.mobileNo}
                    onChange={(e) => handleChange(e.target.value, "mobileNo")}
                  />
                </Col>
              </Row>
              <Row className="rowGroup">
                <Col lg="2">
                  <label
                    htmlFor="example3cols2Input"
                    className="form-control-label"
                  >
                    Card Serial Number
                  </label>
                </Col>
                <Col lg="1">:</Col>
                <Col lg="3">
                  <Input
                    id="example3cols2Input"
                    type="text"
                    placeholder="37842436XXX"
                    name="cardserialnumber"
                    value={upData.cardSerialNo}
                    onChange={(e) =>
                      handleChange(e.target.value, "cardSerialNo")
                    }
                  />
                </Col>
              </Row>
              <Row className="rowGroup">
                <Col lg="2">
                  <label
                    htmlFor="example3cols2Input"
                    className="form-control-label"
                  >
                    Citizen ID
                  </label>
                </Col>
                <Col lg="1">:</Col>
                <Col lg="3">
                  <Input
                    id="example3cols2Input"
                    type="text"
                    placeholder="37842436XXX"
                    name="citizenid"
                    value={upData.citizenId}
                    onChange={(e) => handleChange(e.target.value, "citizenId")}
                  />
                </Col>
              </Row>
              <Row>
                <Button
                  color="primary"
                  disabled={
                    !upData.citizenId &&
                    !upData.mobileNo &&
                    !upData.cardSerialNo
                  }
                  onClick={search}
                >
                  Search
                </Button>

                <Button color="secondary" onClick={clear}>
                  Clear
                </Button>
              </Row>
            </Form>
          </CardBody>
        </Card>
        <Col style={{ marginTop: "35px" }}>
          {dataLoading.profileDataloading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loading style={{ width: "10px", height: "10px" }} />
            </div>
          ) : (
            <>
              {profiledata.map((data) => (
                <Row className="rowGroup">
                  <Col lg="2">
                    <label
                      htmlFor="example3cols2Input"
                      className="form-control-label"
                    >
                      {data.label}
                    </label>
                  </Col>{" "}
                  <Col lg="1">:</Col>
                  <Col lg="9">
                    <label htmlFor="example3cols2Input">{data.value}</label>
                  </Col>
                </Row>
              ))}
            </>
          )}
        </Col>
        {salaryProfile.citizenId > 0 && (
          <Card style={{ marginTop: "25px" }}>
            <Row>
              <Col lg="6">
                <CardBody>
                  <Row className="rowGroup">
                    <CardTitle
                      // className="mb-3"
                      tag="h2"
                      className="user-subheader"
                    >
                      Eligibility Check
                    </CardTitle>
                  </Row>
                  {dataLoading.reasonLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Loading style={{ width: "10px", height: "10px" }} />
                    </div>
                  ) : (
                    <Row style={{ borderBottom: "solid 3px black" }}>
                      <Col lg="12" style={{ padding: "0px" }}>
                        <p>This Employee is ineligible because:</p>
                      </Col>
                      <Col lg="12" style={{ padding: "0px" }}>
                        <p>
                          1. "
                          {resonEligibilty &&
                            resonEligibilty.ResponseDescription}
                          "
                        </p>
                      </Col>
                    </Row>
                  )}

                  <Row style={{ marginTop: "10px" }}>
                    <Col style={{ padding: "0px" }}>
                      <label
                        htmlFor="example3cols2Input"
                        className="form-control-label"
                      >
                        Last 3 salaries
                      </label>
                    </Col>
                  </Row>
                  {historyloading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Loading style={{ width: "10px", height: "10px" }} />
                    </div>
                  ) : (
                    <>
                      {SalaryHistory.map((data) => (
                        <Row className="rowGroup">
                          <Col lg="4">
                            <label
                              htmlFor="example3cols2Input"
                              className="form-control-label"
                            >
                              <span>{data.Month}</span>
                              <span style={{ marginLeft: "4px" }}>
                                {data.Year}
                              </span>
                            </label>
                          </Col>

                          <Col lg="4">
                            <label
                              htmlFor="example3cols2Input"
                              // className="form-control-label"
                              style={{ marginRight: "4px" }}
                            >
                              AED
                            </label>
                            <label htmlFor="example3cols2Input">
                              {data.Amount}{" "}
                            </label>
                          </Col>
                        </Row>
                      ))}
                    </>
                  )}
                </CardBody>
              </Col>
              <Col lg="6">
                <CardBody>
                  <Row className="rowGroup">
                    <CardTitle
                      // className="mb-3"
                      tag="h2"
                      className="user-subheader"
                    >
                      Salary Advance Details
                    </CardTitle>
                  </Row>

                  {detailsLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Loading style={{ width: "10px", height: "10px" }} />
                    </div>
                  ) : (
                    <>
                      {salarydata.map((data) => (
                        <Row className="rowGroup">
                          <Col lg="6" style={{ padding: "0px" }}>
                            <label
                              htmlFor="example3cols2Input"
                              className="form-control-label"
                            >
                              {data.label}
                            </label>
                          </Col>
                          <Col lg="1" style={{ padding: "0px" }}>
                            :
                          </Col>
                          <Col lg="5">
                            <label htmlFor="example3cols2Input">
                              {data.value}
                            </label>
                          </Col>
                        </Row>
                      ))}
                    </>
                  )}
                </CardBody>
              </Col>
            </Row>
          </Card>
        )}
      </Container>
    </>
  );
};

export default SalaryAdvancePresentational;
